import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';

export interface FilterData {
  filter: string;
  AdvanceSearch: any;
}
@Component({
    selector: 'app-view-library',
    templateUrl: './Ecode.component.html',
    styleUrls: ['./Ecode.component.css'],
    standalone: false
})
export class EcodeComponent implements OnInit {
  FormSearchLibrary: FormGroup;
  master: any;
  ECODEMASTER: any;
  ReportID: any;
  ECODEMASTERCASEHISTORY: any;
  ECODEMASTERCASEupdate: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  pageNumber: number;
  DisplayMessage: string;
  FormSearchNoticeCase: FormGroup;
  varInterval: any;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  RequestFrom: string;
  selectedAll: any;
  isSelected: boolean[];
  RightsID: string;
  txtSearch: any;
  DownloadURL: string;
  errorFetch: string;
  name: string;
  eCourt: string;
  Region: string;
  Court: any;
  City: any;
  CNR: any;
  filteredData: any[];
  caseHistoryPageNumber: number = 1;
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) {

    this.url = AppComponent.baseURL;
  }
  ngOnInit() {
    this.MsgType = 0;
    this.FormSearchLibrary = this.formBuilder.group({
      txtSearch: [''], advanceSearchValue: [null]
    });
    this.CNR = "CNR";
    this.getMasterData();
    this.CallPython();
    this.FormSearchLibrary.get('txtSearch').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      this.filterTable(value);
    });
  }

    onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }
  onSearchLibrary(SearchData) {
    // this.fetchLibrary(SearchData.txtSearch);
  }

  validateInsertCNR(event) {
    if (event.CNRValue == '') {
      alert('Insert CNR Data Before Submit!');
      this.onClickInsertCNR(false);
    }
  }
  public onClickInsertCNR(event: any): void {
    event.stopPropagation();
  }

  CallPython() {
    this.eCourt = this.txtSearch.toString();
    var CNRNO = this.eCourt;
    // this.validateInsertCNR(event);
    //event.target.disabled = true;
    // this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + event.CNRValue) // Update CNR by Middleware
    this.http.get(this.url + 'Notice/autoUpdate_Ecourt?cnrid=' + this.eCourt)    // Update CNR by Direct

      .subscribe((data) => {

        if (data == null) {
          //event.target.disabled = false;
          alert(" Updation Failed ");
          //location.reload();
        }
        else if (data == '"Data Already Updated"') {
          //event.target.disabled = false;
          this.master = JSON.parse(data.toString());
          alert("Data Already Updated");


        }
        else if (data == '"Data Not Available on Website."') {
          //event.target.disabled = false;
          //this.alertService.success("Data Already Updated",true);
          this.master = JSON.parse(data.toString());
          //console.log('raw json', this.master);
          alert("Data Not Available on Website.");
          // location.reload();
        }
        else if ((data.toString()).includes('One or more errors occurred.') || (data.toString()).includes('Try Again')) {
          //event.target.disabled = false;
          //this.alertService.error("Data Not Found or Server Error",true);
          this.master = JSON.parse(data.toString());
          alert("Data Not Found or Server Error");
          //location.reload();
        }
        else {
          //event.target.disabled = false;
          //this.alertService.success("Successfully Updated",false);
          this.master = JSON.parse(data.toString());
          this.GETECODEDATA(CNRNO);
          this.GETECODECASEHISTORY(CNRNO);
          alert("Successfully Updated");
          //location.reload();
        }
      }
      );
  }

  GETECODEDATA(CNRNO) {
    // this.validateInsertCNR(event);
    //event.target.disabled = true;
    // this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + event.CNRValue) // Update CNR by Middleware
    this.http.get(this.url + 'Notice/GetECourtDataWithCNR?CNRNO=' + CNRNO)    // Update CNR by Direct
      .subscribe((data) => {
        this.ECODEMASTER = JSON.parse(data.toString());
        this.totalRecords = this.ECODEMASTER.length;
        this.filterTable('');
      }
      );
  }
  GETECODECASEHISTORY(CNRNO) {
    // this.validateInsertCNR(event);
    //event.target.disabled = true;
    // this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + event.CNRValue) // Update CNR by Middleware
    this.http.get(this.url + 'Notice/GetECourtCaseHistoryWithCNR?CNRNO=' + CNRNO)    // Update CNR by Direct

      .subscribe((data) => {
        if(data == null){
          this.MsgType = 3;
        }else{
          this.ECODEMASTERCASEHISTORY = JSON.parse(data.toString());
        }
      }
      );
  }

  GETECODEUPDATESHOW() {
    this.eCourt = this.txtSearch.toString();
    // this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + event.CNRValue) // Update CNR by Middleware
    this.http.get(this.url + 'Notice/GetCNRUPDATESHOW?CNRNO=' + this.eCourt)    // Update CNR by Direct
      .subscribe((data) => {

        alert("Data Upload Sucessfully");
        this.ECODEMASTERCASEupdate = JSON.parse(data.toString());
        //event.target.disabled = false;
        //alert("Data Upload Sucessfully");
        //location.reload();
      }
      );

  }

  DownloadReport(Mode) {
    var newWindow = window.open();
    this.ReportID = "207069005";
    this.DownloadURL = AppComponent.DownloadURL;
    newWindow.document.write('Downloading ...');
    this.http.post(this.url + 'Report/DownloadReportECODE', {
      ReportID: this.ReportID,
      Param: this.advanceSearchValue,
      Level: 0,
      AdditionalFIlter: "",
      Mode: Mode
    }
    )
      .subscribe((data) => {
        newWindow.location.href = this.DownloadURL + data;
        this.varInterval = setInterval(() => {
          if (newWindow.document.readyState == 'complete') {
            newWindow.close();
            clearInterval(this.varInterval);
          }
        }, 200);
      }
      );
  }

  // Write funcation End

  // e-CourtListing
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }

  getMasterData() {
    this.getMaster('135', '').subscribe(data => {
      this.Court = data;
    });
  }

  onCourtSelect(TypeID) {
    this.http.get(this.url + 'Notice/GetEcourtTypeIntergrationName?GenId=135&TYPE=' + TypeID)    // Update CNR by Direct
      .subscribe((data) => {
        if (JSON.parse(data.toString())[0].Description == "null" || JSON.parse(data.toString())[0].Description == "") {
          this.CNR = "CNR";
        }
        else {
          this.CNR = JSON.parse(data.toString())[0].Description;
        }
      });
  }


  // e-CourtListing

  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.ECODEMASTER];
      return;
    }
    this.filteredData = this.ECODEMASTER.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }

}